<template>
  <div>
    <vs-dropdown
      vs-custom-content
      vs-trigger-click
      class="accounts-actions-drop-down"
    >
      <vs-icon class="pt-6" icon-pack="speakol" icon="speakol-more-horizontal"/>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 11rem;" class="menu-items">
          <li
            id="accounts-table-view-button"
            class="flex cursor-pointer hover:bg-gray-200 items-center item-font"
            @click="$router.push({name: 'accounts-view', params: { id: params.data.id }})"
          >
            <vs-icon
              class="flex justify-center items-center"
              size="40px"
              :icon="'speakol-eye'"
              :color="'#2C2C2C'"
              icon-pack="speakol"
              >
            </vs-icon>
            <span>View</span>
          </li>

          <li
            id="accounts-table-verify-button"
            class="flex cursor-pointer hover:bg-gray-200 items-center"
            @click="toggleVerification(params.data.id, 1)"
            v-if="params.data.verification_status != 1"
          >
            <vs-icon
              class="flex justify-center items-center"
              size="40px"
              :icon="'speakol-verify'"
              :color="'#2C2C2C'"
              icon-pack="speakol"
              >
            </vs-icon>
            <span>Verify</span>
          </li>

          <li
            id="accounts-table-verify-button"
            class="flex cursor-pointer hover:bg-gray-200 items-center danger-btn"
            @click="toggleVerification(params.data.id, 3)"
            v-if="params.data.verification_status != 3"
          >
            <vs-icon
              class="flex justify-center items-center"
              size="40px"
              :icon="'speakol-unverify'"
              :color="'#DB2828'"
              icon-pack="speakol"
              >
            </vs-icon>
            <span>Unverify</span>
          </li>

          <li
            v-if="canDelete"
            id="accounts-table-verify-button"
            class="flex cursor-pointer hover:bg-gray-200 items-center danger-btn"
            @click="deleteAccount(params.data.id)"
          >
            <vs-icon
              class="flex justify-center items-center"
              size="40px"
              :icon="'speakol-delete'"
              :color="'#DB2828'"
              icon-pack="speakol"
              >
            </vs-icon>
            <span>Delete</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>

    <delete-account ref="delete-account" :account="params.data"></delete-account>
  </div>
</template>

<script>
import DeleteAccount from './delete-account.vue'

export default {
  components: {
    DeleteAccount
  },

  data () {
    return {
    }
  },
  computed: {
    canDelete () {
      const isSystemDeleteEnabled = this.$hasFeature('system-deletes')

      const isTheActiveAccount = this.params.data.id === this.$store.getters['authentication/activeAccount'].id

      const hasDeletePermission =  this.$can('system_deletion')

      return !isTheActiveAccount && isSystemDeleteEnabled && hasDeletePermission
    }
  },
  methods: {
    async deleteAccount (accountId) {
      this.$refs['delete-account'].deleteAccount(accountId)
    },

    async toggleVerification (accountId, verification_status) {
      const response = await window.axios.post('/accounts/verification-status', {

        account_id: accountId,
        status: verification_status
      })
      if (response.status === 200) {
        this.params.node.setData({
          ...this.params.node.data,
          verification_status: response.data.verification_status
        })
        this.$nextTick(() => {
          this.params.api.refreshCells({
            rowNodes: [this.params.node],
            force: true
          })
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.users-actions-drop-down {
  cursor: pointer;
}

.menu-items {
  .danger-btn {
    color: #db2828;
  }

  .item-font {
    color: #2c2c2c;
  }
}

.speakol-verify,
.speakol-unverify {
  font-size: 18px !important;
}
</style>
